import { render, staticRenderFns } from "./CustomerHome.vue?vue&type=template&id=c2b6d5ba"
import script from "./CustomerHome.vue?vue&type=script&lang=js"
export * from "./CustomerHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports